<template>
  <div class="contactUs" v-wechat-title="$route.meta.title" style="height: 100%;">
    <Header/>
    <BannerBg/>
    <div class="contact_box" style="height: 570px;" id="contact">
      <div class="width6 contact_show wow FadeInR animated" style="float: right;">
        <div class="contact_info">
            <div class="Practices_title">
                <h1>联系我们</h1>
                <span>Contact Us</span>
            </div>
            <div class="contact_info_detail"><span>地址：</span>天津市和平区马场道82号</div>
            <div class="contact_info_detail"><span>邮编：</span>300000</div>
            <div class="contact_info_detail"><span>电话：</span>18222512560</div>
            <div class="contact_info_detail"><span>邮箱：</span><a href="mailto:Xingzheng@LvShi.com.cn">Xingzheng@LvShi.com.cn</a></div>
            <div class="contact_info_detail">
               <img src="@/assets/images/official_account.jpg" title="关注公众号" width="111" height="108" style="float: left;">
            </div>
        </div>
      </div>
      <div class="width6 contact_show wow FadeInL animated">
          <div class="map_box">
            <!-- <div id="allmap"></div> -->
          </div>
      </div>
      <div class="clear"></div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "contactUs",
    mounted() {
      var map = new BMap.Map("allmap");
      var point = new BMap.Point(117.212781,39.115404);
      map.addControl(new BMap.NavigationControl());               // 添加平移缩放控件
      map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
      map.addControl(new BMap.OverviewMapControl());              //添加缩略地图控件
      map.centerAndZoom(point, 16);
      var marker = new BMap.Marker(point);  // 创建标注
      map.addOverlay(marker);               // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
      var opts = {
          width: 200,     // 信息窗口宽度
          height: 100,     // 信息窗口高度
          title: "天津金展律师事务所", // 信息窗口标题
          enableMessage: true,//设置允许信息窗发送短息
          message: ""
      }
      var infoWindow = new BMap.InfoWindow("地址：天津市和平区马场道82号", opts);  // 创建信息窗口对象 
      marker.addEventListener("click", function () {
          map.openInfoWindow(infoWindow, point); //开启信息窗口
      });

      var myStyleJson = [{
        "featureType": "all",
        "elementType": "all",
        "stylers": {
          "lightness": 10,
          "saturation": -100
        }
      }];
      map.setMapStyle({ styleJson: myStyleJson });
    }
  }
</script>